import { useMemo } from 'react';

export interface IHornAnimationVariantsConfig {
  distance: number;
  tiltDeg: number;
  spread: number;
  duration: number; // in seconds
}

const defaultConfig: IHornAnimationVariantsConfig = {
  distance: 7,
  tiltDeg: 18,
  spread: 13,
  duration: 0.7,
};

const transitionHideEase = [0.2, 0.8, 0.2, 1];
const transitionShowEase = ['easeOut', 'easeInOut', 'easeOut'];
const transitionShownTimes = [0, 0.6, 1];

export function useHornsAnimationVariants(config?: Partial<IHornAnimationVariantsConfig>) {
  const { distance, tiltDeg, spread, duration } = { ...defaultConfig, ...config };

  const variants = useMemo(
    () => ({
      containerHidden: {
        y: distance,
        opacity: 0,
        transition: { duration, ease: transitionHideEase },
      },
      containerShown: {
        y: [0, 0, 0],
        opacity: [1, 1, 1],
        transition: {
          duration,
          ease: transitionShowEase,
          times: transitionShownTimes,
        },
      },

      leftHidden: {
        x: 0,
        y: distance,
        rotate: 0,
        transition: { duration, ease: transitionHideEase },
      },
      leftShown: {
        x: [-spread * 0.95, -spread - 1, -spread],
        y: [distance, -1, 0],
        rotate: [-(tiltDeg * 0.96), -(tiltDeg + 1), -tiltDeg],
        transition: {
          duration,
          ease: transitionShowEase,
          times: transitionShownTimes,
        },
      },

      rightHidden: {
        x: 0,
        y: distance,
        rotate: 0,
        transition: { duration, ease: transitionHideEase },
      },
      rightShown: {
        x: [spread * 0.95, spread + 1, spread],
        y: [distance, -1, 0],
        rotate: [tiltDeg * 0.96, tiltDeg + 1, tiltDeg],
        transition: {
          duration,
          ease: transitionShowEase,
          times: transitionShownTimes,
        },
      },
    }),
    [distance, duration, spread, tiltDeg],
  );

  return variants;
}
